import axios from "axios";

export const state = {
    feesexemptions: [],
};

export const getters = {
    feesexemptions: state => state.feesexemptions,
};

export const mutations = {
    setFeesExemptions(state, newValue) {
        state.feesexemptions = newValue
    },
};

export const actions = {
    fetchFeesExemptions({ commit }) {
        axios.get('/feesexemptions').then(res => {
            commit('setFeesExemptions', res.data.exemptions);
        })
    },
};
